import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "bottom-nav"

  connect() {
    super.connect()

    // Hide the web FAB synchronously so it never flashes alongside the native
    // bar after a Turbo reload (e.g. expense save → session.reload()). The
    // native "connected" reply would otherwise be the trigger, and the
    // round-trip latency leaves a visible duplicate during heavy paints.
    this.#hideWebBottomNav()

    requestAnimationFrame(() => {
      const element = this.bridgeElement
      const manualEntryUrl = element.bridgeAttribute("manual-entry-url")
      const reportsUrl = element.bridgeAttribute("reports-url")
      const actionsUrl = element.bridgeAttribute("actions-url")
      const banksUrl = element.bridgeAttribute("banks-url")
      const manualEntryLabel = element.bridgeAttribute("manual-entry-label")
      const reportsLabel = element.bridgeAttribute("reports-label")
      const actionsLabel = element.bridgeAttribute("actions-label")
      const banksLabel = element.bridgeAttribute("banks-label")
      const locale = document.documentElement.lang || "en"

      this.send("connect", { manualEntryUrl, reportsUrl, actionsUrl, banksUrl, manualEntryLabel, reportsLabel, actionsLabel, banksLabel, locale }, (message) => {
        this.#handleCallback(message)
      })
    })
  }

  disconnect() {
    super.disconnect()
    this.#showWebBottomNav()
  }

  // Called by voice-modal controller when modal opens
  hide() {
    this.send("hide", {})
  }

  // Called by voice-modal controller when modal closes
  show() {
    this.send("show", {})
  }

  // Dim the entire screen (including native nav bar) behind the voice modal
  dim() {
    this.send("dim", {})
  }

  // Remove the dimming overlay
  undim() {
    this.send("undim", {})
  }

  // MARK: - Private

  #handleCallback(message) {
    const { event } = message

    if (event === "connected") {
      this.#hideWebBottomNav()
    } else if (event === "fab_tapped") {
      this.#openVoiceModal()
    } else if (event === "manual_entry_tapped") {
      window.Turbo.visit(this.element.dataset.manualEntryUrl)
    } else if (event === "reports_tapped") {
      window.Turbo.visit(this.element.dataset.reportsUrl)
    } else if (event === "actions_tapped") {
      window.Turbo.visit(this.element.dataset.actionsUrl)
    } else if (event === "banks_tapped") {
      window.Turbo.visit(this.element.dataset.banksUrl)
    }
  }

  #openVoiceModal() {
    const phoneCard = this.element.closest("[data-controller~='voice-modal']")
    if (!phoneCard) return

    const voiceModal = this.application.getControllerForElementAndIdentifier(phoneCard, "voice-modal")
    if (voiceModal) {
      voiceModal.open()
    }
  }

  #hideWebBottomNav() {
    const nav = document.querySelector("[data-voice-modal-target='bottomNav']")
    if (nav) nav.style.display = "none"
  }

  #showWebBottomNav() {
    const nav = document.querySelector("[data-voice-modal-target='bottomNav']")
    if (nav) nav.style.display = ""
  }
}
